(function () {
    'use strict';

    angular.module("imApp").factory("stockBatchSearchService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3414,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
